/**
 * Currencies (reference data). One backend source: GET /api/v1/reference/currencies (core
 * ReferenceController). RUB is deliberately absent — but the currency fields in the forms are free-entry,
 * so the client can type any (VITRINE_TOPUP_REQUEST_DESIGN §14.2). Module-cached.
 */
import { http } from './http';

export interface CurrencyRef {
  code: string;
  name: string;
  kind: 'FIAT' | 'CRYPTO';
  minorScale: number;
  networks?: string[] | null;
  /**
   * Фиат, к которому актив привязан один к одному (USDT/USDC → `USD`); null у всего, что плавает.
   *
   * Нужен, чтобы между долларом и долларовым стейблкоином нигде не показывался курс: рынок печатает
   * 0,9995 или 1,0007, и клиент, который вводил 1500, читает в ответ другое число. Признак живёт в
   * справочнике на сервере — следующий стейблкоин это строка данных, а не правка в коде.
   */
  peggedTo?: string | null;
}

let cache: CurrencyRef[] | null = null;
let inflight: Promise<CurrencyRef[]> | null = null;

export async function loadCurrencies(): Promise<CurrencyRef[]> {
  if (cache) return cache;
  if (!inflight) {
    inflight = http.get<CurrencyRef[]>('/v1/reference/currencies')
      .then(r => { cache = r.data; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export async function fiatCurrencies(): Promise<CurrencyRef[]> {
  return (await loadCurrencies()).filter(c => c.kind === 'FIAT');
}
export async function cryptoCurrencies(): Promise<CurrencyRef[]> {
  return (await loadCurrencies()).filter(c => c.kind === 'CRYPTO');
}
